export const applySiteTechnicians = (rows, previousTechnicianIds, technicianIds) => {
  const previousIds = new Set(previousTechnicianIds.map(String));
  const selectedIds = new Set(technicianIds.map(String));

  return rows.map((row) => ({
    ...row,
    technicianIds: Array.from(
      new Map(
        [
          ...technicianIds,
          ...(row.technicianIds || []).filter(
            (id) => !previousIds.has(String(id)) && !selectedIds.has(String(id)),
          ),
        ].map((id) => [String(id), id]),
      ).values(),
    ),
  }));
};